import { render } from "./TopBtn.vue?vue&type=template&id=56ffb08c&scoped=true"
import script from "./TopBtn.vue?vue&type=script&lang=js"
export * from "./TopBtn.vue?vue&type=script&lang=js"

import "./TopBtn.vue?vue&type=style&index=0&id=56ffb08c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ffb08c"]])

export default __exports__